<template>
  <div class="d-flex align-items-end pb-1" style="margin: 80px 0 30px 0;">
    <h2 class="font-weight-bold mr-2 ml-1 mr-1">推荐{{type}}</h2>
    <span class="text-muted">RECOMMENDED&nbsp;&nbsp;&nbsp;HOTEL</span>
    <div class="ml-auto text-login cursor-pointer h5" @click="$router.replace(routeTo)">
      <i class="iconfont h4">&#xe6ec;</i>地图找{{type}}
    </div>
  </div>
</template>

<script>
    export default {
      name: 'HeaderNav',
      props:['type','routeTo'],
    }
</script>
